import styled from 'styled-components/macro'
import { makeStyles } from '@material-ui/core'

export const TableContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  
  @media (max-width: 600px) {
    flex-direction: column;
    font-size: var(--second-font-size);
  }
`;

/* Only the list card — do not style HistoryDetails side panel */
export const TableCardWrap = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  & > div,
  & > div > div {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  & > div > div > div {
    flex: 1;
    min-height: 0;
    overflow: hidden !important;
    padding-bottom: 0 !important;
  }
`;

export const useStyles = makeStyles(() => ({
  noJoined: {
    background: "#fff9d1",
  },
  tbody: {
    // History-only: height from measured prop so small screens stay inside the card
    maxHeight: ({ bodyMaxHeight }) => bodyMaxHeight || 'calc(100vh - 340px)',
    overflow: 'auto',
    display: 'block',
    '& tr': {
      display: 'table',
      tableLayout: 'fixed',
      width: '100%'
    }
  },
  thead: {
    display: 'table',
    tableLayout: 'fixed',
    width: '100%'
  }
}));
